// react imports
import React, { Component } from "react"

// package imports
import { Button, Container, Row, Col } from "react-bootstrap"
import { observer } from "mobx-react"
import moment from "moment"
import { toJS } from "mobx"
import axios from "axios"
import * as APITypes from 'constants/API';

// project imports
import ProposerDetailsCard from "../components/proposer-details-card.js/ProposerDetailsCard"
// import qmsDashboardData from "./qms-dashboard-data"
import QmsStorageKeys from "constants/QmsStorageKeys"
import QmsDashboardPageStore from "./qms-dashboard-page-store"
import SPRM_ENUM from "constants/SPRM_constants";
import isObjectEmpty from "utils/isObjectEmpty";
import StorageKeys from "constants/StorageKeys"
import SolutionCoverageConstant from "constants/SolutionCoverageConstant"
import ProductPackageIdForQms from "constants/ProductPackageIdForQms"

import "./qms-dashboard-page.css"
import QmsSolutionStatus from "constants/QmsSolutionStatus"
import PaginationComponent from "components/ui/pagination"
import SearchBar from "components/ui/searchbar/Searchbar"
import fetchNavigationScreen from "utils/fetchNavigationScreen"
import QmsDropdown from "components/ui/qms-dropdown/QmsDropdown"
import { lowerCase, upperCase } from "lodash"
import { CustomCheckbox } from "components"
import SearchbarWithType from "components/ui/search-bar-with-type/SearchbarWithType"
import MultiSelectWithSearchBox from "components/ui/multi-select-data-with-search-box/MultiSelectWithSearchBox"
import MultiSelectDropdown from "components/ui/multi-select-dropdown/MultiSelectDropdown"
import dummyData from "./dummydata"
import { QMS_BH, QMS_BM, QMS_CH, QMS_DM, QMS_FROM_DATE, QMS_PFA, QMS_PRODUCT, QMS_RH, QMS_RM, QMS_SOLUTION_COVERAGE, QMS_TM, QMS_TO_DATE } from "constants/UserClicksConstant"
import { NEW_QMS_CHANNEL_LIST } from "constants/Constants"

const QmsDashboardPage = observer(
    class QmsDashboardPage extends Component {
        constructor(props) {
            super(props)
            this.state = {
                page: 1,
                search: null,
                regional_heads: { id: null, value: null },
                ch: { id: null, value: null },
                branch_heads: { id: null, value: null },
                dm: { id: null, value: null },
                pfa: { id: null, value: null },
                startDate: '',
                endDate: '',
                agentdata: null,
                summeryData: null,
                showpfa: false,
                selectedType: '',
                selectedTypeValue: '',
                solutionCoverage: [],
                products: [],
                viewFilter: false,
                settitleQuote: "Show PFAs Quote",
                titleQuoteDisabled: false,
                qmsUserClicksList: [],
                searchBarClicklist: []

            }
        }

        async componentDidMount() {
            let agent_id;
            let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];

            let agentsData = []
            let channelName = NEW_QMS_CHANNEL_LIST

            const urlParams = new URLSearchParams(location.search);
            //agent_id = urlParams.get(SPRM_ENUM.AGENT_ID)
            agent_id = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE)
            if (agent_id === undefined || agent_id === null)
                agent_id = localStorage.getItem(QmsStorageKeys.AGENT_ID, agent_id)
            await QmsDashboardPageStore.savePragatiInBoundData(agent_id, this.state.page, this.state.search)

            let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE)
            let origanal_designation_code = localStorage.getItem(QmsStorageKeys.ORIGANAL_DESIGNATION_CODE)
            let agent_name = localStorage.getItem(QmsStorageKeys.AGENT_NAME)
            let agent_code = localStorage.getItem(QmsStorageKeys.AGENT_CODE)

            if (channelName.includes(channel_code)) {
                (channel_code === "DIS" ||channel_code === "CSB" ) ? this.setState({ settitleQuote: "Show RMs Quote" }) : this.setState({ settitleQuote: "Show PFAs Quote" })
                agentsData = await QmsDashboardPageStore.fetchAgentHeirarchy(designation_Code, agent_code, channel_code, origanal_designation_code)
                //  agentsData = dummyData
                console.log("agentsData ", agentsData)
                let current_date = new Date().toISOString().split('T')[0]
                const currentDate = moment();
                currentDate.date(1);
                const formattedDate = currentDate.format('YYYY-MM-DD');
                this.setState({ startDate: formattedDate })
                this.setState({ endDate: current_date })
                if (designation_Code.includes('RH')) {

                    this.setState({ regional_heads: { id: agent_code, value: agent_name } })

                    let response = await QmsDashboardPageStore.fetchJourneySummary(agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value, agent_code, "All", "All", "All", "All", this.state.startDate, this.state.endDate, channel_code)
                    this.setState({ summeryData: response.data })
                    this.setState({ showpfa: true })
                    this.setState({ ch: { id: "All", value: "All" } })
                    this.setState({ branch_heads: { id: "All", value: "All" } })
                    this.setState({ dm: { id: "All", value: "All" } })
                    this.setState({ pfa: { id: "All", value: "All" } })
                    await QmsDashboardPageStore.fetchNewQmsListData(agentsData[3].value, agentsData[4].value, "All", "All", this.state.startDate, this.state.endDate, true, agent_code, this.state.page, this.state.selectedType, this.state.selectedTypeValue, this.state.solutionCoverage, this.state.products, channel_code)

                } else if (designation_Code.includes('CH')) {

                    this.setState({ ch: { id: agent_code, value: agent_name } })
                    let response = await QmsDashboardPageStore.fetchJourneySummary(agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value, null, agent_code, "All", "All", "All", this.state.startDate, this.state.endDate, channel_code)
                    this.setState({ summeryData: response.data })
                    this.setState({ showpfa: true })
                    this.setState({ branch_heads: { id: "All", value: "All" } })
                    this.setState({ dm: { id: "All", value: "All" } })
                    this.setState({ pfa: { id: "All", value: "All" } })
                    await QmsDashboardPageStore.fetchNewQmsListData(agentsData[3].value, agentsData[4].value, "All", "All", this.state.startDate, this.state.endDate, true, agent_code, this.state.page, this.state.selectedType, this.state.selectedTypeValue, this.state.solutionCoverage, this.state.products, channel_code)

                } else if (designation_Code.includes('BH') || designation_Code.includes('TM')) {

                    this.setState({ branch_heads: { id: agent_code, value: agent_name } })
                    let response = await QmsDashboardPageStore.fetchJourneySummary(agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value, null, null, agent_code, "All", "All", this.state.startDate, this.state.endDate, channel_code)
                    this.setState({ summeryData: response.data })
                    this.setState({ showpfa: true })
                    this.setState({ dm: { id: "All", value: "All" } })
                    this.setState({ pfa: { id: "All", value: "All" } })
                    await QmsDashboardPageStore.fetchNewQmsListData(agentsData[3].value, agentsData[4].value, "All", "All", this.state.startDate, this.state.endDate, true, agent_code, this.state.page, this.state.selectedType, this.state.selectedTypeValue, this.state.solutionCoverage, this.state.products, channel_code)

                } else if (designation_Code.includes('DM') || designation_Code.includes('BM')) {

                    this.setState({ dm: { id: agent_code, value: agent_name } })
                    let response = await QmsDashboardPageStore.fetchJourneySummary(agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value, null, null, null, agent_code, "All", this.state.startDate, this.state.endDate, channel_code)
                    this.setState({ summeryData: response.data })
                    this.setState({ showpfa: true })
                    this.setState({ pfa: { id: "All", value: "All" } })
                    await QmsDashboardPageStore.fetchNewQmsListData(agentsData[3].value, agentsData[4].value, agent_code, "All", this.state.startDate, this.state.endDate, true, agent_code, this.state.page, this.state.selectedType, this.state.selectedTypeValue, this.state.solutionCoverage, this.state.products, channel_code)

                } else if (designation_Code.includes('PFA') || designation_Code.includes('RM')) {

                    this.setState({ pfa: { id: agent_code, value: agent_name } })
                    let response = await QmsDashboardPageStore.fetchJourneySummary(agentsData[0].value, agentsData[1].value, agentsData[2].value, agentsData[3].value, agentsData[4].value, null, null, null, null, agent_code, this.state.startDate, this.state.endDate, channel_code)
                    this.setState({ summeryData: response.data })
                    this.setState({ showpfa: true })
                    this.setState({ titleQuoteDisabled: true })
                    await QmsDashboardPageStore.fetchNewQmsListData(agentsData[3].value, agentsData[4].value, null, agent_code, this.state.startDate, this.state.endDate, true, agent_code, this.state.page, this.state.selectedType, this.state.selectedTypeValue, this.state.solutionCoverage, this.state.products, channel_code)

                }
                this.setState({ agentdata: agentsData })

            }
            fetchNavigationScreen()
        }


        async componentDidUpdate(prevProps, prevState) {
            let data = this.state.agentdata
            let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
            let channelName = NEW_QMS_CHANNEL_LIST
            let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE)

            if ((this.state.page !== prevState.page) || (this.state.search !== prevState.search)) {
                let agent_code = localStorage.getItem(QmsStorageKeys.AGENT_CODE)
                let agent_id;
                if (channelName.includes(channel_code)) {
                    //get-New-QMS-List-Data API 
                    let dmID = this.state.dm.id
                    let pfaID = this.state.pfa.id
                    await QmsDashboardPageStore.fetchNewQmsListData(data[3].value, data[4].value, dmID, pfaID, this.state.startDate, this.state.endDate, true, agent_code, this.state.page, this.state.selectedType, this.state.selectedTypeValue, this.state.solutionCoverage, this.state.products, channel_code)
                } else {
                    const urlParams = new URLSearchParams(location.search);
                    agent_id = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE)
                    if (agent_id === undefined || agent_id === null)
                        agent_id = localStorage.getItem(QmsStorageKeys.AGENT_ID, agent_id)
                    await QmsDashboardPageStore.fetchQmsListData(agent_id, this.state.page, this.state.search, agent_code)
                }
            }
        }

        showSingleCard(proposerList) {
            if (proposerList) {
                return proposerList.some((item) => item.solution_list[0].solution_status_id !== QmsSolutionStatus.ANALYSIS_IN_PROGRESS)
            } else {
                return false
            }
        }

        onPageChange(pageNumber) {
            this.setState({ page: pageNumber });
        }
        ondatachanges = (data, name, id) => {

            let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
            if (name === "Region Heads") {
                this.setState({ regional_heads: { id: id, value: data } })
                this.setQmsUserClicksList(QMS_RH)
            }
            else if (name === "CH") {
                this.setState({ ch: { id: id, value: data } })
                let role = channel_code === "IM" ? "tm" : "bh"
                let newagentData = QmsDashboardPageStore.updateAgentHeirarchy(data, this.state.agentdata, role)
                this.setState({ agentdata: newagentData })
                this.setState({ branch_heads: { id: "All", value: "All" } })
                this.setQmsUserClicksList(QMS_CH)
            }
            else if (name === "Branch Heads" || name === "TM") {
                this.setState({ branch_heads: { id: id, value: data } })
                let role = QmsDashboardPageStore.setRole(name, channel_code)
                console.log("role  ", role)
                let newagentData = QmsDashboardPageStore.updateAgentHeirarchy(data, this.state.agentdata, role)
                this.setState({ agentdata: newagentData })
                this.setState({ dm: { id: "All", value: "All" } })
                let click = name === "TM" ? QMS_TM : QMS_BH
                this.setQmsUserClicksList(click)
            }
            else if (name === "DM" || name === "BM") {
                this.setState({ dm: { id: id, value: data } })
                let role = QmsDashboardPageStore.setRole(name, channel_code)
                let newagentData = QmsDashboardPageStore.updateAgentHeirarchy(data, this.state.agentdata, role)
                this.setState({ agentdata: newagentData })
                this.setState({ pfa: { id: "All", value: "All" } })
                let click = name === "DM" ? QMS_DM : QMS_BM
                this.setQmsUserClicksList(click)
            }
            else if (name === "PFA" || name === "RM") {
                this.setState({ pfa: { id: id, value: data } })
                let click = name === "PFA" ? QMS_PFA : QMS_RM
                this.setQmsUserClicksList(click)
            }
            else if (name === "solution coverage") {
                this.setState({ solutionCoverage: data })
                this.setQmsUserClicksList(QMS_SOLUTION_COVERAGE)
            } else if (name === "product") {
                this.setState({ products: data })
                this.setQmsUserClicksList(QMS_PRODUCT)
            }
        }

        onStartDateChange = (startvalue) => {
            this.setState({ startDate: startvalue })
            console.log("startvalue ", startvalue)
        }
        onEndDateChange = (endvalue) => {
            this.setState({ endDate: endvalue })
            console.log("endvalue ", endvalue)
        }

        onSelectedTypeChange = (type, value) => {
            let click = "qms_" + type?.toLowerCase()?.replace(" ", "_");
            this.setState({ selectedType: type })
            this.setState({ selectedTypeValue: value })
            if (type) {
                this.setSearchBarClicksList(click)
            }
        }

        onViewFilter = () => {

            this.setState({ viewFilter: !this.state.viewFilter })

        }

        handleStartDateChange = (event) => {
            this.setQmsUserClicksList(QMS_FROM_DATE)
            this.setState({ startDate: event.target.value })
        }

        handleEndDateChange = (event) => {
            this.setQmsUserClicksList(QMS_TO_DATE)
            this.setState({ endDate: event.target.value })
        }

        handleSearchData = (data) => {
            if (data != '') {
                this.setState({ search: data });
                this.setState({ page: 1 });
            } else {
                this.setState({ search: null });
            }
        }

        filterData = async () => {
            let data = this.state.agentdata
            let agent_code = localStorage.getItem(QmsStorageKeys.AGENT_CODE)
            let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE)
            let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
            let rhID = this.state.regional_heads.id
            let bhID = this.state.branch_heads.id
            let dmID = this.state.dm.id
            let pfaID = this.state.pfa.id
            let chID = this.state.ch.id
            let showPfa = this.state.titleQuotetitleQuote ? true : this.state.showpfa
            //for soluction
            let solution = this.state.solutionCoverage.includes("All") ? ["All"] : this.state.solutionCoverage
            //fetch-Journey-summery API 
            let response = await QmsDashboardPageStore.fetchJourneySummary(data[0].value, data[1].value, data[2].value, data[3].value, data[4].value, rhID, chID, bhID, dmID, pfaID, this.state.startDate, this.state.endDate, channel_code)
            this.setState({ summeryData: response.data })
            //get-New-QMS-List-Data API 
            await QmsDashboardPageStore.fetchNewQmsListData(data[3].value, data[4].value, dmID, pfaID, this.state.startDate, this.state.endDate, showPfa, agent_code, this.state.page, this.state.selectedType, this.state.selectedTypeValue, solution, this.state.products, channel_code)
            // this.setState({ showpfa: showPfa })
            console.log("qmsUserClicksList ", this.state.qmsUserClicksList)
            if (this.state.qmsUserClicksList.length > 0) {
                QmsDashboardPageStore.saveQMSUserMultipleClicks(this.state.qmsUserClicksList, agent_code)
                this.setState({ qmsUserClicksList: [] })
            }
            console.log("qmsUserClicksList ", this.state.qmsUserClicksList)

        }
        showQmsList = async (showPFA, searchType) => {
            let data = this.state.agentdata
            let agent_code = localStorage.getItem(QmsStorageKeys.AGENT_CODE)
            let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE)
            let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
            let dmID = this.state.dm.id
            let pfaID = this.state.pfa.id

            //get-New-QMS-List-Data API
            await QmsDashboardPageStore.fetchNewQmsListData(data[3].value, data[4].value, dmID, pfaID, this.state.startDate, this.state.endDate, showPFA, agent_code, this.state.page, this.state.selectedType, this.state.selectedTypeValue, this.state.solutionCoverage, this.state.products, channel_code)
            switch (searchType) {
                case "search_bar":
                    if (this.state.selectedType && this.state.searchBarClicklist.length > 0) {     
                        QmsDashboardPageStore.saveQMSUserMultipleClicks(this.state.searchBarClicklist, agent_code)
                        this.setState({ searchBarClicklist: [] })
                    }
                    break;

                case "checkbox_pfa":
                    if (this.state.qmsUserClicksList.length > 0) {

                        QmsDashboardPageStore.saveQMSUserMultipleClicks(this.state.qmsUserClicksList, agent_code)
                        this.setState({ qmsUserClicksList: [] })
                    }
                    break;
                default:
                    break;
            }
        }

        setQmsUserClicksList = (value) => {
            if (!this.state.qmsUserClicksList.includes(value)) {
                this.setState(prevState => ({
                    qmsUserClicksList: [...prevState.qmsUserClicksList, value]
                }));
            }

        }
        setSearchBarClicksList = (value) => {
            if (!this.state.searchBarClicklist.includes(value)) {
                this.setState(prevState => ({
                    searchBarClicklist: [...prevState.searchBarClicklist, value]
                }));
            }

        }
        render() {
            let qmsDashboardData = toJS(QmsDashboardPageStore.qmsListData)
            let agent = this.state.agentdata
            let summaryData = this.state.summeryData
            let channelName = NEW_QMS_CHANNEL_LIST
            let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
            let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE)
            return (
                ((!isObjectEmpty(qmsDashboardData) || channelName.includes(channel_code)) && QmsDashboardPageStore.selectedScreen === "Quotes & Applications [10]") ?
                    <Container className="qms-dashboard-page  mt-5 mt-md-3">

                        {channelName.includes(channel_code) ?
                            <>
                                <div className="row">
                                    <div className="col-4 col-lg-6">
                                        <Button className="w-100 mt-2 font-size-14 view-filter" onClick={this.onViewFilter}>{this.state.viewFilter ? "Hide Filters" : "View Filters"}</Button>
                                    </div>
                                    <div className="col-8 col-lg-6">
                                        <SearchbarWithType
                                            onSelectedTypeChange={this.onSelectedTypeChange.bind(this)}
                                            searchButtonClick={this.showQmsList.bind(this)}

                                        />
                                    </div>
                                </div>
                                {this.state.viewFilter &&
                                    <div className="mb-3">
                                        <div className="row">
                                            {agent &&
                                                <>{
                                                    agent.map((item, index) => {
                                                        return (
                                                            <>
                                                                <div className=" col-3-5 ">
                                                                    <div className='d-flex justify-content-between align-items-center'>
                                                                        <p className='font-size-14 mb-2 agent-name'>{QmsDashboardPageStore.agentName(item.key)}</p>
                                                                    </div>
                                                                    <QmsDropdown
                                                                        title={QmsDashboardPageStore.agentName(item.key)}
                                                                        item={item.value}
                                                                        menuItemStyle='d-flex justify-content-between align-items-center'
                                                                        dropdownStyle=' font-size-14 '
                                                                        datachnages={this.ondatachanges.bind(this)}
                                                                        RHs={this.state.regional_heads.value}
                                                                        BHs={this.state.branch_heads.value}
                                                                        DMs={this.state.dm.value}
                                                                        PFAs={this.state.pfa.value}
                                                                        CHs={this.state.ch.value}
                                                                    // DATEs={this.state.date_filter}
                                                                    />
                                                                </div>

                                                            </>
                                                        )
                                                    })
                                                }

                                                    <div className=" col-3-5 ">
                                                        <div className='d-flex justify-content-between align-items-center mt-1 mt-lg-0'>
                                                            <p className='font-size-14 mb-2 agent-name'>From Date</p>
                                                        </div>

                                                        <input
                                                            type="date"
                                                            id="startDate"
                                                            name="startDate"
                                                            className='date-range-picker'
                                                            value={this.state.startDate}
                                                            onChange={this.handleStartDateChange}
                                                            max={this.state.endDate}
                                                        />
                                                    </div>
                                                    <div className=" col-3-5 ">
                                                        <div className='d-flex justify-content-between align-items-center mt-2 mt-lg-0'>
                                                            <p className='font-size-14 mb-2 agent-name'>To Date</p>
                                                        </div>

                                                        <input
                                                            type="date"
                                                            id="endDate"
                                                            name="endDate"
                                                            className='date-range-picker'
                                                            value={this.state.endDate}
                                                            onChange={this.handleEndDateChange}
                                                            min={this.state.startDate}
                                                            max={new Date().toISOString().split('T')[0]}
                                                        />
                                                    </div>
                                                </>
                                            }
                                            <div className="col-3-5 ">
                                                <div className='d-flex justify-content-between align-items-center mt-2 mt-lg-0 '>
                                                    <p className='font-size-14 mb-2 agent-name'>Product</p>
                                                </div>
                                                <MultiSelectWithSearchBox
                                                    productsList={ProductPackageIdForQms.value}
                                                    datachnages={this.ondatachanges.bind(this)}
                                                />
                                            </div>
                                            <div className="col-3-5 ">
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <p className='font-size-14 mb-2 agent-name'>{QmsDashboardPageStore.agentName(SolutionCoverageConstant.key)}</p>
                                                </div>
                                                <MultiSelectDropdown
                                                    datachnages={this.ondatachanges.bind(this)}
                                                />

                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-end">
                                            <div className="qms-filter-button ">
                                                <Button className="drp-applyBtn-Style rounded-pill font-size-16 w-100" onClick={this.filterData} >Filter</Button>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col-lg-10 mb-3">
                                        {summaryData &&
                                            <>
                                                <div >
                                                    <table className="summary-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Role</th>
                                                                <th>No. of Users</th>
                                                                <th>No. of Journeys Started</th>
                                                                <th>No. of Solutions Started</th>
                                                                <th>No. of Logins</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.keys(summaryData).map((data, index) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td className="font-weight-medium">{upperCase(data)}</td>
                                                                            <td>{summaryData[data]?.number_of_users}</td>
                                                                            <td>{summaryData[data]?.journeys}</td>
                                                                            <td>{summaryData[data]?.solutions}</td>
                                                                            <td>{summaryData[data]?.policies}</td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div className="col-lg-2 mt-2">
                                        {summaryData &&
                                            <div className="d-flex justify-content-end mt-lg-5">
                                                <CustomCheckbox
                                                    shape="rounded"
                                                    title={this.state.settitleQuote}
                                                    titleStyle=' font-weight-medium font-size-14 pl-2 text-primary'
                                                    isChecked={this.state.showpfa}
                                                    onChange={(value) => {
                                                        this.setState({ showpfa: value })
                                                        this.showQmsList(!this.state.showpfa, "checkbox_pfa")
                                                    }
                                                    }
                                                    disabled={this.state.titleQuoteDisabled}
                                                    mark="checkmark"
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </>
                            :
                            < SearchBar onData={this.handleSearchData} />
                        }

                        {/* <MultiSelectDropdown /> */}




                        {(!isObjectEmpty(qmsDashboardData) && qmsDashboardData?.all_journey_lists.length === 0) &&
                            <div className="text-center mt-3  mt-md-5">
                                <p className="font-size-20 font-size-md-30 text-danger">No Data Found Please Reset Your Filters.</p>
                            </div>
                        }

                        {qmsDashboardData?.all_journey_lists?.map((journeyListData, journeyListIndex) =>
                            <React.Fragment key={`all-journey-list-` + journeyListIndex}>
                                <p className="font-size-10 font-weight-medium date-filter">{journeyListData?.date ? moment(journeyListData?.date).format("DD-MM-YYYY") : "DD-MM-YYYY"}</p>
                                {journeyListData?.journey_list?.map((journeyData, journeyIndex) =>
                                    <div key={"journey-key-" + journeyData.journey_id + journeyIndex} className={`${journeyData?.proposer_list?.length > 1 && "parent pb-2"}`}>

                                        {!this.showSingleCard(journeyData?.proposer_list) ?
                                            <ProposerDetailsCard
                                                // proposerDataList={journeyData?.proposer_list[0].product_details}
                                                proposerData={journeyData?.proposer_list?.length > 0 ? journeyData?.proposer_list[0] : {}}
                                                proposerList={journeyData.proposer_list}
                                                proposerIndex={0}
                                                journeyData={journeyData}
                                                showSingleCard={false}
                                                {...this.props}
                                            />
                                            : journeyData?.proposer_list?.map((proposerData, proposerIndex) =>
                                                <React.Fragment key={"proposer-key-" + proposerData.proposer_id + proposerIndex}>
                                                    {journeyData?.proposer_list?.length > 1 && proposerIndex === 0 &&
                                                        <p className={`font-size-14 font-weight-medium client-name mb-4`}>{QmsDashboardPageStore.getFamilyMemberName(journeyData.journey_self_data, true, journeyData, false)} & Family - Journey ID:{journeyData.journey_id}</p>
                                                    }

                                                    <div className={`${journeyData?.proposer_list?.length > 1 && "child ml-5"}`}>
                                                        <ProposerDetailsCard
                                                            // proposerDataList={proposerData.product_details}
                                                            proposerData={proposerData}
                                                            proposerList={journeyData.proposer_list}
                                                            proposerIndex={proposerIndex}
                                                            journeyData={journeyData}
                                                            showSingleCard={journeyData.proposer_list.length > 1}
                                                            {...this.props}
                                                        />

                                                    </div>
                                                </React.Fragment>
                                            )}
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                        {
                            (!isObjectEmpty(qmsDashboardData) && this.state.search === null && qmsDashboardData.number_of_pages !== 1) && <PaginationComponent
                                onChangePage={this.onPageChange.bind(this)}
                                // totalItemCount={100}
                                selectedPage={this.state.page}
                                totalPageCount={qmsDashboardData?.number_of_pages}
                            />
                        }
                    </Container >
                    : <div></div>
            )
        }
    }
)

export default QmsDashboardPage
